import { noop } from 'underscore';

const isDebugLoggingEnabled = true;

const jsonArgsSerializer = (...args) => args.map(JSON.stringify);
const identityArgsSerializer = (...args) => args;

const logF = argsSerializer => (isDebugLoggingEnabled ?
  (msg, ...args) => {
    // eslint-disable-next-line
    console.log(`[DWD] ${msg}`, ...(argsSerializer(...args)));
  } :
  noop
);

export const log = logF(identityArgsSerializer);
export const logJson = logF(jsonArgsSerializer);

export const logWrapper = (tag, func, toJson) => {
  const logg = toJson ? logJson : log;

  return (...args) => {
    logg(`${tag}.ENTER: args=_`, ...args);
    let ret;
    try {
      ret = func(...args);
      return ret;
    } finally {
      // logg(`${tag}.EXIT: ret=_`, ret);
    }
  };
};

export const logAction = (msg, ...args) =>
  (context, event) =>
    log(`${(context && context.id) || 'UNKNOWN'}: ${msg}`, ...args, context, event);

export const stateLoggingListener = (state) => {
  // subscribes to state changes
  log(`${state && state.machine && state.machine.id}: state=_`, state);
};
